
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/login",
      function () {
        return require("private-next-pages/[country]/[language]/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]/[language]/login"])
      });
    }
  